import React from "react";

export const useGridRowData = ({ schema, targets, merchantId, columnDefs, displayedRows }) =>
    React.useMemo(() => {
        const blankRowData = columnDefs.reduce((acc: { [key: string]: string }, { field }) => {
            // if it's a colgroup, there is no field and no need for values since
            // colgroups children will get it from valueGetter functions
            if (!field) {
                return acc;
            }
            acc[field] = null;
            return acc;
        }, {});

        const mappedRowData = targets.reduce((acc, target) => {
            // we are adding targetMetricsType to every row to prevent further iterations
            const defaultKeys = {
                targetMetricsType: target.budgetTarget,
            };

            // creating an id to each target row so we can use it in the columns
            // value getter to know which method to use
            // the first row has the image key because it's the one that renders the name of the target
            // TODO image key should be the the filters name which comes from the hook, not the value
            const targetDependenciesValues =
                target.filters?.reduce((acc, { field_name, value }) => {
                    acc[field_name] = { value, type: undefined };
                    return acc;
                }, {}) ?? {};

            const mappedImageRowData = schema.reduce(
                (acc, schemakey) => {
                    const existentKey = acc.dependenciesValues[schemakey.field_name];
                    if (existentKey) {
                        acc.dependenciesValues[schemakey.field_name] = {
                            ...existentKey,
                            type: schemakey.value_type,
                        };
                        return {
                            ...acc,
                            schema: [...acc.schema, schemakey],
                            dependenciesValues: { ...acc.dependenciesValues },
                        };
                    }
                    return acc;
                },
                {
                    schema: [],
                    dependenciesValues: targetDependenciesValues,
                    description: target.targetGroupName,
                    merchantId,
                }
            );

            const displayedRowsKeys = Object.keys(displayedRows);
            const rowData = displayedRowsKeys.reduce((acc, key, keyIndex) => {
                const isRowActive = displayedRows[key];

                if (isRowActive) {
                    acc.push({
                        ...blankRowData,
                        id: `${target.targetId}|${key}`,
                        rowType: key,
                        ...defaultKeys,
                    });
                }
                return acc;
            }, []);

            // giving the first row the image data so it can display the target's info
            rowData[0] = { ...rowData[0], targetInfo: mappedImageRowData };

            return [...acc, ...rowData];
        }, []);

        return mappedRowData;
    }, [schema, targets, merchantId, columnDefs, displayedRows]);
